import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { Community } from "../../../../models";

@Component({
  selector: "invite-to-community-modal",
  templateUrl: "./invite-to-community-modal.component.html",
  styleUrls: [
    "./invite-to-community-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class InviteToCommunityModal implements OnInit {
  @Input() community: Community;
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
